<template>
	<div :style="cssVars" :class="'text-field text-field--' + alignment">
		<slot> </slot>
	</div>
</template>

<script>
export default {
	props: {
		alignment: {
			default: 'default',
			enum: ['left', 'right', 'center'],
		},
		color: {
			type: String,
			default: '#353535',
		},
		maxWidth: {
			type: String,
			default: '100%',
		},
	},
	computed: {
		cssVars() {
			return {
				'--tx-color': this.color,
				'--tx-max-width': this.maxWidth,
			}
		},
	},
}
</script>

<style lang="scss">
.text-field {
	color: var(--tx-color);
	max-width: var(--tx-max-width);
	width: 100%;
	&--left {
		float: left;
	}
	&--center {
		margin: auto;
	}
	&--right {
		float: right;
	}
}
</style>
